import Barba from "barba.js";
import $ from 'jquery';

const Resources = Barba.BaseView.extend({
  namespace: "resources",
  onEnter() {},
  onEnterCompleted() {
    const filterParams = {
      category: null,
      type: null,
    }

    const setHeadline = () => {
      let cat = filterParams.category;
      let type = filterParams.type;
      let typeHTML = $('.type-select option[value=' + type + ']').html();
      let catHTML = $('.cat-select option[value=' + cat + ']').html();
      if($('.visible').length < 1 ){
        $('.resources-widget__headline').html("Sorry, we don't have anything that fits your request.")
      }
      else if(cat === null && type === null){
        $('.resources-widget__headline').html('Latest Resources')
      }
      else if(cat && type){
        $('.resources-widget__headline').html(`Showing ${typeHTML} related to ${catHTML}`)
      }
      else if(cat){
        $('.resources-widget__headline').html(`Showing everything related to ${catHTML}`)
      }
      else if(type){
        $('.resources-widget__headline').html(`Showing all ${typeHTML}`)
      }
    }

    const selected = (item) => {
      let cats = item.attr('data-categories');
      cats = cats.split(/(\s+)/);

      let type = item.attr('data-type');
      if(filterParams.category && !(cats.indexOf(filterParams.category) > -1)){
        return false;
      }
      else if(filterParams.type && filterParams.type !== type){
        return false;
      }
      else{
        return true;
      }
    }

    const filterListings = () => {
      $('.resources-widget__result').each(function(){
        if(selected($(this))){
          $(this).addClass('visible')
        }
        else{
          $(this).removeClass('visible')
        }
      })
      setHeadline()
    }

    $('.type-select').change(function(){
      if($(this).val() == "all"){
        filterParams.type = null;
      }
      else{
        filterParams.type = $(this).val();
      }
    });

    $('.cat-select').change(function(){
      if($(this).val() == "all"){
        filterParams.category = null;
      }
      else{
        filterParams.category = $(this).val();
      }
    });

    $('.resources-widget__submit').click(function(){
      filterListings();
    })

  },
  onLeave() {
    this.destroy();
  },
  $el: null,
  _construct() {},
  destroy() {}
});

export default Resources;



// WEBPACK FOOTER //
// ./src/scripts/barba/views/resources.js